import { render } from "./DialogViewer.vue?vue&type=template&id=25b2c876&ts=true"
import script from "./DialogViewer.vue?vue&type=script&lang=ts"
export * from "./DialogViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__